var e = /* @__PURE__ */ ((r) => (r.deDE = "de-DE", r.enUs = "en-US", r.frFr = "fr-FR", r))(e || {});
export {
  e as Lang
};
